import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { hasAssignments } from '@/shared/components/security/HasAssignments';

import enumCache from '@/shared/services/EnumCacheService';
import DataCacheService from '@/shared/services/DataCacheService';
import AssignedToSelector from '@/shared/components/input/AssignedToSelector';
import Checkbox from '@/shared/components/input/Checkbox';
import { getUserClassName } from '@/shared/components/input/UserSearch';

import messages from '../invoiceStreamMessages';

export default class UpdateInvoiceStreamUserModal extends Component {
  state = {
    profile: null,
    userId: null,
    updateRelation: true,
    resetInvoiceStreams: false,
    profiles: [],
    users: [],
    updateTasks: false,
    updateTaskData: {
      assignedType: 0,
      assignedUserId: null,
      assignedProfile: null,
    },
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  componentDidMount() {
    const { intl } = this.props;
    enumCache.getTranslated('employeeprofile', intl).then(profiles => {
      this.setState({
        profiles,
        users: DataCacheService.getUsers(),
      });
    });
  }
  isFormInvalid = () => {
    const { updateRelation, profile, userId, updateTasks, updateTaskData } = this.state;
    if (profile === null) return true;

    return false;
  };

  onSave = () => {
    const {
      profile,
      userId,
      updateRelation,
      resetInvoiceStreams,
      updateTasks,
      updateTaskData,
    } = this.state;
    const { onSave } = this.props;

    let updateTaskModel = null;
    if (updateTasks) {
      if (!userId) {
        // User data from assigned user control when user is set to unassigned
        updateTaskModel = {
          oldProfile: profile,
          assignedType: updateTaskData.assignedType,
          newProfile: updateTaskData.assignedProfile,
          newUserId: updateTaskData.assignedUserId,
        };
      } else {
        // Replace with new user
        updateTaskModel = {
          oldProfile: profile,
          assignedType: 2,
          newProfile: null,
          newUserId: userId,
        };
      }
    }
    const model = {
      profile,
      userId,
      updateTasks: updateTaskModel,
      updateRelation,
      resetInvoiceStreams,
    };
    return onSave(model);
  };

  updateRelationChanged = e => {
    this.setState({ updateRelation: e.target.value === 'true' });
  };

  profileChanged = event => {
    const profile = parseInt(event.target.value) || 0;
    this.setState({
      profile,
    });
  };
  userChanged = event => {
    this.setState({
      userId: event.target.value || null,
    });
  };
  assignedToChanged = assignedTo => {
    this.setState({
      updateTaskData: assignedTo,
    });
  };

  render() {
    const { show, onClose, intl } = this.props;
    const {
      updateRelation,
      resetInvoiceStreams,
      users,
      profiles,
      profile,
      userId,
      updateTasks,
    } = this.state;
    const showAdvancedOptions = hasAssignments();
    const showAssignedToSelector = updateRelation && profile !== null && !userId && updateTasks;
    const assignedToProfiles = showAssignedToSelector
      ? profiles.filter(x => x.id !== profile)
      : undefined;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.UpdateInvoiceStreamUser)}
        show={show}
        onClose={onClose}
        disabled={this.isFormInvalid()}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          {showAdvancedOptions ? (
            <div className="form-group">
              <div className="col-md-12">
                <div className="radio">
                  <label>
                    <input
                      type="radio"
                      name="updateRelation"
                      id="updateRelation1"
                      value="true"
                      checked={!!updateRelation}
                      onChange={this.updateRelationChanged}
                    />
                    {intl.formatMessage(messages.UpdateUserForSelectedRelations)}
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="updateRelation"
                      id="updateRelation2"
                      value="false"
                      checked={!updateRelation}
                      onChange={this.updateRelationChanged}
                    />
                    {intl.formatMessage(messages.UpdateUserForSelectedInvoiceStreams)}
                  </label>
                </div>
              </div>
            </div>
          ) : null}
          <div className="form-group">
            <div className="col-md-6">
              <select onChange={this.profileChanged} className="form-control" value={profile || ''}>
                {!profile && <option value="">{intl.formatMessage(messages.SelectAField)}</option>}
                {profiles.map(x => (
                  <option key={x.id} value={x.id}>
                    {x.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6">
              <select onChange={this.userChanged} className="form-control" value={userId || ''}>
                <option value="">
                  {intl.formatMessage(
                    updateRelation ? messages.Unassigned : messages.UseRelationSetting,
                  )}
                </option>
                {users.map(x => (
                  <option key={x.id} value={x.id} className={getUserClassName(x)}>
                    {x.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {showAdvancedOptions && updateRelation ? (
            <div className="form-group">
              <div className="col-md-12">
                <label className="react-toggle-wrapper margin5T">
                  <Toggle
                    checked={resetInvoiceStreams}
                    onChange={e => this.setState({ resetInvoiceStreams: !!e.target.checked })}
                  />
                  <span className="label-text">
                    {intl.formatMessage(messages.AlsoResetUserForSelectedInvoiceStreams)}
                  </span>
                </label>
              </div>
            </div>
          ) : null}

          {profile !== null && (
            <div className="form-group">
              <div className="col-md-12">
                <label className="react-toggle-wrapper margin5T">
                  <Toggle
                    checked={updateTasks}
                    onChange={e => this.setState({ updateTasks: !!e.target.checked })}
                  />
                  <span className="label-text">
                    {intl.formatMessage(messages.UpdateUserInPlannedTasks)}
                  </span>
                </label>
              </div>
            </div>
          )}
          {showAssignedToSelector && (
            <div className="form-group">
              <label className="col-md-12">
                {intl.formatMessage(
                  messages.RelationUserIsUnassignedWhichUserDoYouWantToAssignToTasks,
                )}
              </label>
              <div className="col-md-12">
                <AssignedToSelector
                  onChange={this.assignedToChanged}
                  profiles={assignedToProfiles}
                />
              </div>
            </div>
          )}
        </div>
      </OkCancelModal>
    );
  }
}
